import React, { Component } from 'react';
import { getIcon, isEmpty } from '../../Common/Common';
import communication_error_icon from '../../../Images/Daikin_Images/image/CommError.png';
import device_error_icon from '../../../Images/Daikin_Images/image/Error.png';

export default class Display_Group_Cell_Icon extends Component {
	constructor(props) {
		super(props);

		this.areDevicesOn = false;
		this.displayDeviceErrorIcon = false;
		this.displayCommunicationErrorIcon = false;

		this.state = {

		}
	}

	handleCheckAllDeviceStatus = () => {
		let areDevicesOnTemp = false;
		let displayDeviceErrorIconTemp = false;
		let displayCommunicationErrorIconTemp = false;

		if (!isEmpty(this.props.group_info)) {
			let groupName = this.props.group_info.name; 																	//name of the management group
			let groupManagementPoints = this.props.group_info.mp; 															//the management points in the group
			if (!isEmpty(groupManagementPoints)) {
				for (let point_id of groupManagementPoints) { 																//for each management point in the group
					let point_info = window.app.state.point_list[point_id];
					if (!isEmpty(point_info)) {
						let mpName = point_info.name; 																		//management point name
						if (point_info.hasOwnProperty('comm_stat')) {
							let communication_status = point_info.comm_stat;
							if (communication_status) { 																		//if management point doesnt have any communication error
								if (point_info.hasOwnProperty('stat')) {
									let mpStatus = point_info.stat; 														//management point status
									if (mpStatus === 'on') { 																	//if management point status is on
										areDevicesOnTemp = true;
									}
								}
							} else {
								displayCommunicationErrorIconTemp = true;
							}
						}

						if (point_info.hasOwnProperty('error')) {
							let deviceError = point_info.error;
							for (var key in deviceError) { 																	//check every jsonObject in error
								if (deviceError[key]) { 																		//check value of the jsonObject is true 
									displayDeviceErrorIconTemp = true;
								}
							}
						}
					}
				}
			}
		}


		this.areDevicesOn = areDevicesOnTemp;
		this.displayDeviceErrorIcon = displayDeviceErrorIconTemp;
		this.displayCommunicationErrorIcon = displayCommunicationErrorIconTemp;
	}

	render() {
		let group_info = this.props.group_info;

		let icon = getIcon(group_info.icon);

		let img_width = this.props.cell_width / 3;
		//let temp_img_width = (0.133) * this.props.cell_width;

		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';

		this.handleCheckAllDeviceStatus();

		return (
			<div style={this.areDevicesOn ?
				{ textAlign: 'center', marginLeft: -5, width: img_width + 30, height: img_width + 30, display: 'inline-block', backgroundImage: background_gradient, borderRadius: 35 } :
				{ textAlign: 'center', marginLeft: -5, width: img_width + 30, height: img_width + 30, display: 'inline-block', backgroundImage: null, borderRadius: 35 }}>
				<img src={icon} style={{ width: img_width, paddingTop: 15 }} />
				<div style={{ position: 'absolute' }}>
					<img src={communication_error_icon} style={{ width: img_width / 2, position: 'absolute', top: -50, left: 5, visibility: this.displayCommunicationErrorIcon ? 'visible' : 'hidden' }} />
					<img src={device_error_icon} style={{ width: img_width / 2, position: 'absolute', top: this.displayCommunicationErrorIcon ? -25 : -50, left: 5, visibility: this.displayDeviceErrorIcon ? 'visible' : 'hidden' }} />
				</div>
			</div>
		)
	}
}